import { getAssociatedRecordsUtils, getAssociationInfoFromAssociationValue, getAssociationInfoFromPropertySuffix, getAssociationOption, getAssociationOptionByValue, getAssociationUniqueIdentifier } from 'customer-data-filters-ui/utils/associatedRecordsUtils';
import { useEffect, useState } from 'react';
import I18n from 'I18n';
// @ts-expect-error untyped
import ReferenceInputEnum from 'customer-data-reference-ui-components/ReferenceInputEnum';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import { View } from 'foundations-components/components/View';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import UISelect from 'UIComponents/input/UISelect';
import EditorRelatedConditionsHeadingAssociationSelectValueComponent from '../editor/EditorRelatedConditionsHeadingAssociationSelectValueComponent';
import { ObjectTypeIdRegex, isAnyEventTypeId } from '../../filterQueryFormat/ObjectTypeId';
import { useStrategy } from '../../hooks/useStrategy';
import getIn from 'transmute/getIn';
import { ASSOCIATION_DIRECTION } from '../../filterQueryFormat/associations/AssociationUtilities';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FilterOperatorAssociationInput = ({
  condition,
  data,
  error,
  filterFamily,
  inputUse,
  onBlur,
  onChange,
  resolver
}) => {
  const {
    getObjectInverseAssociationOptions
  } = useStrategy();
  const {
    getAssociationDefinition,
    getObjectTypeIdFromPropertySuffix,
    getObjectTypeOptions,
    getCustomObjectReferenceResolver
  } = getAssociatedRecordsUtils(data, filterFamily);
  const prevAssociatedObjectTypeId = getObjectTypeIdFromPropertySuffix(condition.propertySuffix);
  const [associatedObjectTypeId, setAssociatedObjectTypeId] = useState(prevAssociatedObjectTypeId);
  const options = getObjectTypeOptions();
  const isError = error.get('error');
  const errorMessage = error.get('message');
  const [showAssociationSelect, setShowAssociationSelect] = useState(false);
  const [associationOptions, setAssociationOptions] = useState();
  const [associationValue, setAssociationValue] = useState();
  const onHideAssociationSelect = () => {
    setShowAssociationSelect(false);
    setAssociationOptions(undefined);
    setAssociationValue(undefined);
  };
  useEffect(() => {
    setAssociatedObjectTypeId(prevAssociatedObjectTypeId);
  }, [prevAssociatedObjectTypeId]);
  useEffect(() => {
    if (associatedObjectTypeId && prevAssociatedObjectTypeId === associatedObjectTypeId && condition.value) {
      const isAssnFilterFamily = ObjectTypeIdRegex.test(associatedObjectTypeId) && !isAnyEventTypeId(associatedObjectTypeId);
      const newAssociationOptions = isAssnFilterFamily && getObjectInverseAssociationOptions(associatedObjectTypeId);
      if (!!newAssociationOptions && newAssociationOptions.length > 0) {
        setShowAssociationSelect(true);
        setAssociationOptions(newAssociationOptions);
        const {
          associationId: associationInverseId,
          associationCategory
        } = getAssociationInfoFromPropertySuffix(condition.propertySuffix);
        const associationOption = getAssociationOption(newAssociationOptions, associationInverseId, associationCategory, ASSOCIATION_DIRECTION.INVERSE);
        if (associationOption) {
          setAssociationValue(associationOption.value);
        }
      } else {
        onHideAssociationSelect();
      }
    }
    // below disabled because of `getObjectInverseAssociationOptions`
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [associatedObjectTypeId, condition, filterFamily, prevAssociatedObjectTypeId]);
  const onInputChange = (newAssociatedObjectTypeId, newValue, newAssociationValue) => {
    const {
      associationId,
      associationCategory
    } = getAssociationInfoFromAssociationValue(newAssociationValue);
    const associationDefinition = getAssociationDefinition(newAssociatedObjectTypeId, associationId, associationCategory, ASSOCIATION_DIRECTION.INVERSE);
    if (associationDefinition) {
      const associationUniqueIdentifier = getAssociationUniqueIdentifier(associationDefinition);
      if (associationUniqueIdentifier) {
        onChange(syntheticEvent(condition.merge({
          propertySuffix: associationUniqueIdentifier,
          value: newValue
        })));
      }
    }
  };
  const onSelectInputChange = evt => {
    setAssociatedObjectTypeId(evt.target.value);
    onHideAssociationSelect();
  };
  const onEnumInputChange = evt => {
    if (!associatedObjectTypeId) {
      return;
    }
    onInputChange(associatedObjectTypeId, evt.target.value);
  };
  const onEnumInputOpenChange = evt => {
    if (evt.target.value === false && onBlur) {
      onBlur();
    }
  };
  const onAssociationValueChange = evt => {
    const newAssociationValue = evt.target.value;
    setAssociationValue(newAssociationValue);
    const associationOption = getAssociationOptionByValue(associationOptions, newAssociationValue);
    if (associatedObjectTypeId && associationOption) {
      onInputChange(associatedObjectTypeId, condition.value, associationOption.value);
    }
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UISelect, {
      buttonUse: inputUse === 'on-dark' ? 'form-on-dark' : undefined,
      onChange: onSelectInputChange,
      options: options,
      value: associatedObjectTypeId
    }), associatedObjectTypeId && /*#__PURE__*/_jsx(FormControl, {
      "aria-label": I18n.text('customerDataFiltersUI.customerDataFilters.FilterOperatorInput.ariaLabel'),
      error: isError,
      validationMessage: isError ? errorMessage : null,
      children: /*#__PURE__*/_jsx(View, {
        marginInlineStart: "0",
        marginBlockStart: "200",
        children: /*#__PURE__*/_jsx(ReferenceInputEnum, {
          buttonUse: inputUse === 'on-dark' ? 'form-on-dark' : undefined
          // used for rerendering options
          ,

          onChange: onEnumInputChange,
          onOpenChange: onEnumInputOpenChange,
          resolver: getCustomObjectReferenceResolver(resolver, associatedObjectTypeId),
          value: prevAssociatedObjectTypeId === associatedObjectTypeId ? condition.value : undefined
        }, associatedObjectTypeId)
      })
    }), showAssociationSelect && /*#__PURE__*/_jsx(UISelect, {
      buttonUse: inputUse === 'on-dark' ? 'form-on-dark' : undefined,
      className: "m-left-0 m-top-2",
      onChange: onAssociationValueChange
      //@ts-expect-error wrong options type
      ,
      options: associationOptions,
      value: associationValue || getIn([0, 'value'], associationOptions),
      valueComponent: EditorRelatedConditionsHeadingAssociationSelectValueComponent
    })]
  });
};
export default FilterOperatorAssociationInput;